'use client'
import type { ReactNode } from 'react'
import { createContext } from 'react'
import type { UIGlobalsContextType } from './types'

export const UIGlobalsContext = createContext<UIGlobalsContextType>({} as UIGlobalsContextType)

interface UIGlobalsContextProps {
  children: ReactNode
  value: UIGlobalsContextType
}

function UIGlobalsContextProvider({ children, value }: UIGlobalsContextProps) {
  return <UIGlobalsContext.Provider value={value}>{children}</UIGlobalsContext.Provider>
}

export default UIGlobalsContextProvider
